import { Injectable } from '@angular/core';
import { ApolloQueryResult } from '@apollo/client/core';
import { SEARCH_QUERY } from '@shared/consts/graphql';
import { Brand, Series } from '@shared/graphql/generated';
import { BaseService } from '@shared/services/base.service';
import { map, Observable, take } from 'rxjs';

export interface SearchResults {
  brands: Brand[];
  series: Series[];
}

@Injectable({
  providedIn: 'root'
})
export class SearchService extends BaseService<any> {
  getResults(query: string, pageSize: number = 3): Observable<SearchResults> {
    return this.dataStateService.checkAndGetData(
      `searchResults_${query}`,
      this.apollo.watchQuery({
        query: SEARCH_QUERY,
        variables: { query, take: pageSize }
      }).valueChanges
        .pipe(
          take(1),
          map((result: ApolloQueryResult<{ searchBrands: Brand[]; searchSeries: Series[] }>) => {
            const { searchBrands: brands, searchSeries: series } = result.data;

            return {
              brands: brands.filter((brand: Brand) => !!brand.series_count),
              series,
            };
          }),
        ),
      { brands: [], series: [] },
    );
  }
}
